export class PromotoraGestaoAcaoDTO {
  public idPromotora!: number;
  public observacao!: string;
  public codigosChecklistCorrecao!: number[];
  public idsDocumentosCorrecao!: string[];
  public incluirNovoDocumento!: boolean;
  public nomeNovoDocumento!: string;
  public nomesNovosDocumentos!: string[];
  public nomeArquivoContrato!: string;
  public arquivoContratoBase64!: string;
}
